export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_44-928df3176441d5ae2cde7cc61a38bd5d.jpg";